module.exports = __webpack_public_path__ + "media/images/bg/patterns/triangles-light-fd039c89ed3e1fdc4303b1ac379bebc6.svg";